// extracted by mini-css-extract-plugin
export var metaNavigation = "navigation-meta-module--meta-navigation--ioO1f";